import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Candidates|Program History|Exams|Modify Exam`;

export type ModCandExamLoc =
	| 'SPModCandExamScaledScoreLabel'
	| 'SPModCandExamScaledScoreError'
	| 'SPModCandExamLabelAuthId'
	| 'SPModCandExamLabelDisplayDate';

export const modCandExamLocs: LocDefs<ModCandExamLoc> = {
	SPModCandExamScaledScoreLabel: {
		defaultValue: 'Scaled Score',
		description: 'Label for scaled score field.',
		displayPath: `${dpRoot}|Scaled Score Label`,
		displayType: 'Label',
		portal: 'SP',
	},
	SPModCandExamScaledScoreError: {
		defaultValue: 'This field must be a positive number',
		description: 'Scaled score error message.',
		displayPath: `${dpRoot}|Scaled Score Error`,
		displayType: 'Error',
		portal: 'SP',
	},
	SPModCandExamLabelAuthId: {
		defaultValue: 'Exam Authorization ID',
		description: 'Label for the Exam Authorization ID field in the modify candidate exam modal',
		displayPath: `${dpRoot}|Exam Authorization ID`,
		displayType: 'Label',
		portal: 'SP',
		feature: HubFeature.ExamAuthorization,
	},
	SPModCandExamLabelDisplayDate: {
		defaultValue: 'Display Date',
		description: 'Label for the Display Date field in the modify candidate exam modal',
		displayPath: `${dpRoot}|Display Date`,
		displayType: 'Label',
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<ModCandExamLoc>(modCandExamLocs);
